import type { HintV2Attributes } from '@/features/hint-v2/hint-v2-type';

import { Headline, HtmlTextWrapper } from '@/core/features';
import Hint from '@/core/features/hint/hint';
import logger from '@/core/features/logger/logger';

export default function HintV2({ background, border, iconUrl, textComponents, title }: HintV2Attributes) {
    return (
        <Hint
            background={background}
            highlightBorder={border}
            iconUrl={iconUrl}
            title={title}
        >
            {textComponents.map((component, index) => {
                switch (component['@type']) {
                    case 'HeadlineV1': {
                        const { htmlTitle, titleType } = component.attributes;
                        return (
                            <Headline
                                fontWeight={'bold'}
                                htmlTitle={htmlTitle}
                                key={`${component['@type']}-${index}`}
                                marginBottom={-8}
                                marginTop={0}
                                type={titleType}
                            />
                        );
                    }
                    case 'TextV1':
                        return (
                            <HtmlTextWrapper
                                htmlText={component.attributes.htmlText}
                                key={`${component['@type']}-${index}`}
                            />
                        );
                    default:
                        logger.error(`Unknown text component type "${component['@type']}" in HintV2`);
                }

                return null;
            })}
        </Hint>
    );
}
